module.exports = __webpack_public_path__ + "img/asset17.6550c343.png";